import { render, staticRenderFns } from "./MainSearch.vue?vue&type=template&id=8639a41c&scoped=true&"
import script from "./MainSearch.vue?vue&type=script&lang=js&"
export * from "./MainSearch.vue?vue&type=script&lang=js&"
import style0 from "./MainSearch.vue?vue&type=style&index=0&id=8639a41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8639a41c",
  null
  
)

export default component.exports